import { useCallback, useMemo } from 'react';

import { useAuth } from 'modules/authentication/presentation/contexts';
import IEventTrackerProvider from 'shared/domain/providers/IEventTrackerProvider';
import { makeEventTrackerProvider } from 'shared/infra/providers';
import { useRoute } from 'shared/presentation/contexts';
import {
  getSessionReferrer,
  getUtmsFromUrl,
} from 'shared/presentation/helpers';

type TRegisterParams = Parameters<IEventTrackerProvider['register']>;
type TParams = { userId?: number } & Parameters<
  typeof makeEventTrackerProvider
>[0];

export default function useEventTracker(params: TParams = {}) {
  const eventTracker = useMemo(
    () => makeEventTrackerProvider(params),
    [params],
  );
  const route = useRoute();
  const { session } = useAuth();

  const register = useCallback(
    (event: TRegisterParams['0'], payload: TRegisterParams['2'] = {}) => {
      const utms = getUtmsFromUrl();
      const referrer = getSessionReferrer();

      eventTracker.register(
        event,
        {
          device: navigator.userAgent,
          route: route.pathname,
          userId: params.userId || session?.id,
        },
        {
          utms,
          ...(referrer ? { referrer } : {}),
          ...payload,
        },
      );
    },
    [eventTracker, route, session?.id, params.userId],
  );

  return { register };
}
